import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL
let UserType = JSON.parse(localStorage.getItem("WWINGS_USER_TYPE"))

export const createClaimFormAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/create-claimform`,
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error creating claims:", error)
    throw error
  }
}

export const getClaimAPI = async (payload) => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  if (UserType === "Admin") {
    return await axios.post(`${apiBaseUrl}/allClaims`, 
      payload,
      {headers}
    )
  } else {
    return await axios.post(`${apiBaseUrl}/myClaims`, 
      payload,
      {headers}
    )
  }
}


export const updateClaimAPI = async payload => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }
  try {
    const response = await axios.post(
      `${apiBaseUrl}/update-claimform`,
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error updating claim:", error)
    throw error
  }
}


export const sortclaimAPI = async (payload) => {
  try {
  
    
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/view-ClaimReport`, 
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}


export const viewClaimFormAPI = async payload => {
  try {
    const data = {
      customer_id: payload,
    }
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/view-claimform`,
      data,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error to view claimform:", error)
    throw error
  }
}

export const createClaimLinkAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/create-claimLink`,
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error creating claim Link:", error)
    throw error
  }
}


export const viewClaimLinkAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/view-poilcyClaimLink`,
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error View claim Link:", error)
    throw error
  }
}



export const submitClaimLinkAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
    
      "Access-Control-Allow-Origin": "*",
      'Content-Type': 'multipart/form-data',
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/submit-claimLink`,
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error Submit claim Link:", error)
    throw error
  }
}

export const customerPolicyClaimAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
    
      "Access-Control-Allow-Origin": "*",
    //  'Content-Type': 'multipart/form-data',
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/customer-policy-claim`,
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error customer-policy-claim:", error)
    throw error
  }
}

export const customerPolicyLOB= async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
    
      "Access-Control-Allow-Origin": "*",
    //  'Content-Type': 'multipart/form-data',
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/customer-PolicyLOB`,
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error ccustomer-PolicyLOB:", error)
    throw error
  }
}